import { memo } from 'react';
import ConsultantCarousel from '../../Organisms/ConsultantCarousel/ConsultantCarousel';

const ConsultantsComponent = (props) => {
  const { consultantList, parameters } = props;

  return (
    <>
      {consultantList?.length > 0 && (
        <div className="container pt-2 px-0">
          <ConsultantCarousel
            {...{
              nameCourse: props.nameCourse,
              consultantList,
              parameters,
              justConsultant: props.justConsultant,
              props: props
            }}
          />
        </div>
      )}
    </>
  );
};

export default memo(ConsultantsComponent);
